import React, {useContext} from "react";
import {Form, Input, SelectArray, Media, Fields, Container, Checkbox} from "../../components/Form/Form";
// import countryCodes from "../../data/countryCodes";
import useCompanyService from "../../api/services/useCompanyService";
import {useNavigate, useParams} from "react-router-dom";
import SelectArrayIcons from "../../components/Form/SelectArrayIcons";
import CompanyUsers from "../../components/Form/CompanyUsers";
import useForm from "../../hooks/useForm";
import Address from "../../components/Form/Address";
import bookingPaymentTimingEnum from "../../data/bookingPaymentTimingEnum";
import paymentMethodEnum from "../../data/paymentMethodEnum";
import companyTypeEnum from "../../data/companyTypeEnum";
import AuthContext from "../../context/AuthContext";
import AnchorIndex from "../../components/AnchorMenu/AnchorIndex";
import AnchorTitle from "../../components/AnchorMenu/AnchorTitle";
import CompanyValidation from "../../components/Form/CompanyValidation";
import VerifyIban from "../../components/Form/VerifyIban";
import useValidationIban from "../../hooks/useValidationIban";
import VerifyCoc from "../../components/Form/VerifyCoc";
import useValidateCoc from "../../hooks/useValidateCoc";
import useFunction from "../../hooks/useFunction";

const UserCompanyEdit = () => {

  //todo er is een error als je geen companies hebt, 2 toevoegd, en dan 2 verwijderd. (mss afbeelding; default afbeelding of demo data afbeelding error. Check even)
  const {id} = useParams();
  const companyService = useCompanyService()
  const form = useForm()
  const navigate = useNavigate()
  const {user} = useContext(AuthContext)
  const {onClickValidateIban} = useValidationIban(id, form, '/user/organisatie/' + id + '/edit/')
  const {onClickValidateCoc} = useValidateCoc(id, form)
  const {objIsEmpty} = useFunction()

  return (
    <div className="page-user-company">
      <h1>Account/organisatie Instellingen</h1>
      <Form>
        <Fields
          id={id}
          form={form}
          apiService={companyService}
          GAEventLabel="User Company Edit"
          showDelete={(!objIsEmpty(user) && user.is_admin)}
          deleteLabel="Alleen voor Standplaats admins: Verwijder bedrijf, gekoppelde stands/locaties, de koppeling tussen bedrijf en gebruikers, en alle verstuurd/ontvangen berichten (definitief)"
          deleteSuccess={() => navigate('/user/organisaties')}
        >

          <AnchorIndex
            titles={[
              {
                label: 'Algemeen',
                id: 'general'
              },
              {
                label: 'Verificatie',
                id: 'verification'
              },
              {
                label: 'Financieel',
                id: 'financial'
              },
              {
                label: 'Gebruikers en toegang',
                id: 'users'
              },
            ]}
          />
          <br/>
          <CompanyValidation
            name="is_verified"
          />
          <AnchorTitle
            label="Algemeen"
            id="general"
          />

          <Media
            label="Logo"
            name="logo_media"
            width={120}
            height={120}
            size="logo"
          />

          <h3>Type account, organisatie / bedrijfsgegevens & KVK</h3>

          <SelectArrayIcons
            label="Type account:"
            name="type"
            data={companyTypeEnum}
          />

          {/*Conditional show legal_name field*/}
          <Input
            label="Account naam"
            name="legal_name"
            placeholder="Voorbeeld: De groentebroers"
            disabled={form.formData.model.is_verified}
            enabledBy={[{key: 'type', value: 'non-official'}]}
          />
          <Input
            label="Officiële bedrijfs naam"
            name="legal_name"
            placeholder="Voorbeeld: Standplaats.nl BV"
            disabled={form.formData.model.is_verified}
            enabledBy={[{key: 'type', value: 'commercial'}]}
          />
          <Input
            label="Organisatie naam"
            name="legal_name"
            placeholder="Voorbeeld: Gemeente Utrecht"
            disabled={form.formData.model.is_verified}
            enabledBy={[{key: 'type', value: 'public'}]}
          />
          <Input
            label="Organisatie naam"
            name="legal_name"
            placeholder="Voorbeeld: Stichting Verse groente"
            disabled={form.formData.model.is_verified}
            enabledBy={[{key: 'type', value: 'non-profit'}]}
          />
          {/* end conditional show legal_name field*/}

          <Container
            disabledBy={[{key: 'type', value: 'non-official'}]}
          >
            <>
              <hr/>
              <h3>Contactgegevens </h3>
            </>
          </Container>

          <Input
            label="Telefoonnummer"
            name="phone"
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />

          <Container
            disabledBy={[{key: 'type', value: 'non-official'}]}
          >
            <>
              <hr/>
              <h3>Adres</h3>
            </>
          </Container>

          <Address
            text="Het adres waar je account/organisatie berijkbaar is."
            name="address"
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />

          <AnchorTitle
            label="Verificatie"
            id="verification"
          />

          <CompanyValidation
            name="is_verified"
          />

          <Container
            disabledBy={[{key: 'type', value: 'non-official'}]}
          >
            <>
              <p>Om de 'geverifieerd' badge te krijgen voor je bedrijf, of om op factuur (achteraf) te kunnen betalen,
                of om
                inkomsten uit verhuur te kunnen ontvangen is het nodig om je bedrijfsnaam, kvk-nummer en IBAN te
                valideren.</p>

              <h4>Stap 1, verifieer IBAN</h4>

            </>
          </Container>

          <VerifyIban
            label="IBAN nummer"
            name="iban_verified_at"
            validateButtonOnClick={onClickValidateIban}
            validateButtonLabel={"IBAN ophalen via iDeal"}
            removeOtherFields={['iban_number', 'iban_holder_name']}
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />
          <br/>

          <Input
            label="IBAN account nummer"
            // placeholder="NL99BANK0000000000"
            name="iban_number"
            disabled={true}
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />
          <Input
            label="IBAN tenaamstelling"
            name="iban_holder_name"
            disabled={true}
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />

          <Container
            disabledBy={[{key: 'type', value: 'non-official'}]}
          >
            <h4>Stap 2, verifieer KVK</h4>
          </Container>

          {/*<SelectArray*/}
          {/*  label="Land van inschrijving (KvK)"*/}
          {/*  name="country_code"*/}
          {/*  value={'nl'}*/}
          {/*  disabled={true}*/}
          {/*  data={countryCodes}*/}
          {/*/>*/}

          <Input
            label="KVK Nummer"
            name="coc_number"
            disabledBy={[{key: 'type', value: 'non-official'}]}
            disabled={form.formData.model.coc_number_verified_at}
          />

          <VerifyCoc
            label="KVK nummer"
            name="coc_number_verified_at"
            validateButtonOnClick={onClickValidateCoc}
            validateButtonLabel={"KvK validatie uitvoeren"}
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />

          <hr/>
          <br/>
          <br/>
          <br/>
          <AnchorTitle
            label="Financieel"
            id="financial"
          />
          <Input
            label="BTW Nummer"
            name="vat_number"
            disabledBy={[{key: 'type', value: 'non-official'}]}
          />
          <SelectArray
            label="Op factuur (achteraf) betalen van boekingen toestaan (alleen mogelijk na validatie IBAN)"
            name="default_payment_timing"
            disabledBy={[{key: 'type', value: 'non-official'}]}
            data={bookingPaymentTimingEnum}
          />
          <SelectArray
            label="Standaart betaalmethode"
            name="default_payment_method"
            data={paymentMethodEnum}
          />

          <Checkbox
            label="Accepteer de automatische incasso voorwaarden"
            text="Ik geef toestemming aan Standplaats.nl om de verschuldigde bedragen automatisch van mijn bankrekening af te schrijven via SEPA-incasso. Ik ben ermee bekend dat ik de incasso kan terugboeken conform de SEPA-regels en dat deze toestemming geldt voor toekomstige betalingen met betrekking tot mijn boekingen bij Standplaats.nl. Ik begrijp dat bij een stornering door mijn bank de door Mollie in rekening gebrachte kosten aan mij doorberekend kunnen worden."
            name="accepted_direct_debit_at"
            enabledBy={[{key: 'default_payment_method', value: 'direct-debit'}]}
          />

          <AnchorTitle
            label="Gebruikers en toegang"
            id="users"
          />

          <CompanyUsers/>
        </Fields>
      </Form>
    </div>
  )
}

export default UserCompanyEdit
